import { makeVar } from '@apollo/client'
import { userVar } from './user'

/**
 * The wallet the user plays with: the connected wallet while it is linked to
 * the account, otherwise null. Game transactions are signed only by it;
 * which wallet is connected is the user's choice (`wallet-choice.ts`).
 */
export const playWalletAddressVar = makeVar<string | null>(null)

export enum PlayWalletStatus {
  ready = 'ready',
  notLinked = 'notLinked'
}

export const getPlayWalletStatus = (
  connectedAddress: string,
  linkedAddresses: string[]
): PlayWalletStatus =>
  linkedAddresses.includes(connectedAddress) ?
    PlayWalletStatus.ready
  : PlayWalletStatus.notLinked

/**
 * Last line of defence before a game or treasury transaction is signed.
 * On-chain activity from a wallet that is not linked to the account is
 * attributed to an auto-created Anonymous user, and that wallet can then never
 * be linked, so such a transaction must never reach the wallet for signing.
 */
export const assertPlayWallet = (connectedAddress: string | undefined) => {
  const linkedAddresses = userVar()?.wallets.map(wallet => wallet.address) ?? []

  if (!connectedAddress) throw new Error('Wallet not connected')

  if (
    getPlayWalletStatus(connectedAddress, linkedAddresses) ===
    PlayWalletStatus.notLinked
  ) {
    throw new Error(
      'The connected wallet is not linked to your account. Link it before playing.'
    )
  }
}
